import { api } from "../api/Middleware";
import {
  API_URL,
  ACCOUNT_PLAN_CURRENT_URL,
  ACCOUNT_PLAN_SUBSCRIBE_URL,
  ACCOUNT_PLAN_UPGRADE_URL,
  ACCOUNT_PLAN_UPGRADE_PREVIEW_URL,
  ACCOUNT_PLAN_CANCEL_PREVIEW_URL,
  ACCOUNT_PLAN_CANCEL_URL
} from "../api/Urls";

// =============================
// PLAN SERVICES
// =============================

const PLANS_URL = API_URL + "plans/";

// =============================
// DADOS ESTÁTICOS DOS PLANOS
// (Enquanto o endpoint do backend não está pronto)
// =============================

//TEM QUE OBTER OS FEATURES DIRETAMENTE DA API
export const PLAN_RESOURCES = {
  gratuito: {
    id: 6,
    name: "Gratuito",
    description: "Plano gratuito para uso pessoal com recursos limitados",
    highlight: false,
    monthly_value: 0,
    usage_type: 1,
    resources: {
      agents: { label: "Agente publicado", value: 1, unit: "agente", icon: "IconRobot" },
      playground: { label: "Agentes ilimitados para testes no Playground", value: true, is_boolean: true, icon: "IconDeviceGamepad" },
      contacts_base: { label: "Base de Clientes", value: 100, unit: "contatos", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 100, unit: "contatos", icon: "IconLayoutKanban" },
      schedules: { label: "Agendas", value: 1, unit: "agenda", icon: "IconCalendar" },
      products: { label: "Produtos", value: 20, unit: "produtos", icon: "IconBox" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 0, unit: null, icon: "IconBrandWhatsapp", is_disabled: true },
      subaccounts: { label: "Subcontas", value: 0, unit: null, icon: "IconBuilding", is_disabled: true },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Chat", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  starter: {
    id: 7,
    name: "Starter",
    description: "Plano Starter para uso pessoal com mais recursos",
    highlight: true,
    monthly_value: 347,
    usage_type: 1,
    resources: {
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, icon: "IconBrandWhatsapp" },
      agents: { label: "Agente publicado", value: 1, unit: "agente", icon: "IconRobot" },
      playground: { label: "Agentes ilimitados para testes no Playground", value: true, is_boolean: true, icon: "IconDeviceGamepad" },
      users: { label: "Usuários", value: 2, unit: "usuários", icon: "IconUsers" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      courses: { label: "Cursos", value: "Básicos e intermediários", unit: null, icon: "IconSchool" },
      whatsapp_chat: { label: "Chat estilo WhatsApp Web", value: true, is_boolean: true, icon: "IconMessage" },
      products: { label: "Produtos", value: 50, unit: "produtos", icon: "IconBox" },
      contacts_base: { label: "Base de Clientes", value: 1000, unit: "contatos", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 1000, unit: "contatos", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 2000, unit: "mensagens/mês", icon: "IconSend" },
      schedules: { label: "Agendas", value: 2, unit: "agendas", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Chat", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  ondemand: {
    id: 3,
    name: "OnDemand",
    description: "Ideal para começar com IA no atendimento",
    highlight: false,
    monthly_value: 247,
    usage_type: 2,
    resources: {
      subaccounts: { label: "Subcontas", value: 1, unit: "subconta", icon: "IconBuilding" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, unit: "por subconta", icon: "IconBrandWhatsapp" },
      agents: { label: "Agentes para testes", value: "Ilimitados", unit: null, is_unlimited: true, icon: "IconRobot" },
      users_per_subaccount: { label: "Usuários por subconta", value: 1, unit: "usuário", icon: "IconUsers" },
      marketplace_agents: { label: "Agentes no Marketplace", value: 1, unit: "agente", icon: "IconShoppingCart" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      courses: { label: "Cursos", value: "Básicos e intermediários", unit: null, icon: "IconSchool" },
      whatsapp_chat: { label: "Chat estilo WhatsApp Web", value: true, is_boolean: true, icon: "IconMessage" },
      playground: { label: "Playground de testes", value: true, is_boolean: true, icon: "IconDeviceGamepad" },
      products: { label: "Produtos", value: 30, unit: "produtos", icon: "IconBox" },
      contacts_base: { label: "Base de Clientes", value: 1000, unit: "contatos/subconta", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 1000, unit: "contatos/subconta", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 2000, unit: "mensagens/mês/subconta", icon: "IconSend" },
      schedules: { label: "Agendas", value: 2, unit: "agendas", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Chat", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  business: {
    id: 5,
    name: "Business",
    description: "Para empresas que precisam escalar",
    highlight: true,
    monthly_value: 897,
    usage_type: 2,
    resources: {
      whitelabel: { label: "Marca personalizada (White Label)", value: true, is_boolean: true, icon: "IconBrandingWatermark" },
      subaccounts: { label: "Subcontas", value: 6, unit: "subconta", note: "Adicional disponível", icon: "IconBuilding" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, unit: "por subconta", note: "Adicional disponível", icon: "IconBrandWhatsapp" },
      agents: { label: "Agentes", value: "Ilimitados", unit: null, is_unlimited: true, icon: "IconRobot" },
      users_per_subaccount: { label: "Usuários por subconta", value: 5, unit: "usuários", note: "Adicional disponível", icon: "IconUsers" },
      marketplace_agents: { label: "Agentes no Marketplace", value: 40, unit: "agentes", icon: "IconShoppingCart" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      courses: { label: "Cursos", value: "Básicos e intermediários", unit: null, icon: "IconSchool" },
      whatsapp_chat: { label: "Chat estilo WhatsApp Web", value: true, is_boolean: true, icon: "IconMessage" },
      playground: { label: "Playground de testes", value: true, is_boolean: true, icon: "IconDeviceGamepad" },
      products: { label: "Produtos", value: 30, unit: "produtos", icon: "IconBox" },
      contacts_base: { label: "Base de Clientes", value: 3000, unit: "contatos/subconta", note: "Adicional disponível", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 3000, unit: "contatos/subconta", note: "Adicional disponível", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 5000, unit: "mensagens/mês/subconta", note: "Adicional disponível", icon: "IconSend" },
      schedules: { label: "Agendas", value: 5, unit: "agendas", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Chat", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  personal_business: {
    id: 8,
    name: "Business",
    description: "Plano Business pessoal com mais recursos para crescer",
    highlight: true,
    monthly_value: 497,
    usage_type: 1,
    resources: {
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, icon: "IconBrandWhatsapp" },
      agents: { label: "Agente publicado", value: 1, unit: "agente", icon: "IconRobot" },
      playground: { label: "Agentes ilimitados para testes no Playground", value: true, is_boolean: true, icon: "IconDeviceGamepad" },
      users: { label: "Usuários", value: 3, unit: "usuários", icon: "IconUsers" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      courses: { label: "Cursos", value: "Básicos e intermediários", unit: null, icon: "IconSchool" },
      whatsapp_chat: { label: "Chat estilo WhatsApp Web", value: true, is_boolean: true, icon: "IconMessage" },
      contacts_base: { label: "Base de Clientes", value: 3000, unit: "contatos", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 3000, unit: "contatos", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 5000, unit: "mensagens/mês", icon: "IconSend" },
      schedules: { label: "Agendas", value: 10, unit: "agendas", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Chat", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  white_label: {
    id: 9,
    name: "White Label",
    description: "Sua marca, sua plataforma",
    highlight: false,
    monthly_value: 497,
    usage_type: 2,
    resources: {
      subaccounts: { label: "Subcontas", value: 3, unit: "subcontas", icon: "IconBuilding" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, icon: "IconBrandWhatsapp" },
      agents: { label: "Agente publicado por subconta", value: 1, unit: "agente", icon: "IconRobot" },
      users_per_subaccount: { label: "Usuários por subconta", value: 2, unit: "usuários", icon: "IconUsers" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      contacts_base: { label: "Base de Clientes", value: 1000, unit: "contatos", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 1000, unit: "contatos", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 2000, unit: "mensagens/mês", icon: "IconSend" },
      schedules: { label: "Agendas", value: 2, unit: "agendas", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "WhatsApp", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  wl_plus: {
    id: 10,
    name: "White Label Plus",
    description: "Escale seu negócio com mais subcontas",
    highlight: true,
    monthly_value: 897,
    usage_type: 2,
    resources: {
      subaccounts: { label: "Subcontas", value: 6, unit: "subcontas", icon: "IconBuilding" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, icon: "IconBrandWhatsapp" },
      agents: { label: "Agente publicado por subconta", value: 1, unit: "agente", icon: "IconRobot" },
      users_per_subaccount: { label: "Usuários por subconta", value: 3, unit: "usuários", icon: "IconUsers" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      contacts_base: { label: "Base de Clientes", value: 2000, unit: "contatos/subconta", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 2000, unit: "contatos/subconta", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 4000, unit: "mensagens/mês/subconta", icon: "IconSend" },
      schedules: { label: "Agendas", value: 5, unit: "agendas/subconta", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "WhatsApp", unit: null, icon: "IconHeadset" }
    },
    addons: []
  },
  wl_pro: {
    id: 11,
    name: "White Label Pro",
    description: "Máximo desempenho com consultoria inclusa",
    highlight: true,
    monthly_value: 1497,
    usage_type: 2,
    resources: {
      consultoria: { label: "Consultoria mensal", value: "1h/mês", unit: null, icon: "IconHeadset", is_highlight: true },
      subaccounts: { label: "Subcontas", value: 10, unit: "subcontas", icon: "IconBuilding" },
      whatsapp_instances: { label: "Instâncias WhatsApp", value: 1, icon: "IconBrandWhatsapp" },
      agents: { label: "Agente publicado por subconta", value: 1, unit: "agente", icon: "IconRobot" },
      users_per_subaccount: { label: "Usuários por subconta", value: 5, unit: "usuários", icon: "IconUsers" },
      management_platform: { label: "Plataforma de gestão completa", value: true, is_boolean: true, icon: "IconLayoutDashboard" },
      contacts_base: { label: "Base de Clientes", value: 3000, unit: "contatos/subconta", icon: "IconAddressBook" },
      pipeline_crm: { label: "Pipeline CRM", value: 3000, unit: "contatos/subconta", icon: "IconLayoutKanban" },
      whatsapp_messages: { label: "Mensagens WhatsApp", value: 5000, unit: "mensagens/mês/subconta", icon: "IconSend" },
      schedules: { label: "Agendas", value: 10, unit: "agendas/subconta", icon: "IconCalendar" },
      tags: { label: "Tags", value: true, is_boolean: true, icon: "IconTag" },
      support: { label: "Suporte", value: "Prioritário WhatsApp", unit: null, icon: "IconHeadset" }
    },
    addons: []
  }
};

// Categorias de recursos para organização visual
export const RESOURCE_CATEGORIES = {
  ACCOUNTS: {
    id: "accounts",
    title: "Contas e Acessos",
    icon: "IconUsers",
    resources: ["subaccounts", "whatsapp_instances", "users_per_subaccount"]
  },
  AGENTS: {
    id: "agents",
    title: "Agentes e IA",
    icon: "IconRobot",
    resources: ["agents", "marketplace_agents"]
  },
  PLATFORM: {
    id: "platform",
    title: "Plataforma",
    icon: "IconLayoutDashboard",
    resources: ["management_platform", "courses", "whatsapp_chat", "playground"]
  },
  LIMITS: {
    id: "limits",
    title: "Limites e Capacidade",
    icon: "IconChartBar",
    resources: ["products", "contacts_base", "pipeline_crm", "whatsapp_messages", "schedules", "tags"]
  },
  SUPPORT: {
    id: "support",
    title: "Suporte",
    icon: "IconHeadset",
    resources: ["support"]
  }
};

// =============================
// API FUNCTIONS
// =============================

// Listar todos os planos disponíveis
export const getAvailablePlans = async () => {
  try {
    const response = await api.get(PLANS_URL);
    return response;
  } catch (error) {
    // Fallback para dados estáticos se API não disponível
    console.warn("API de planos não disponível, usando dados estáticos");
    return { data: { plans: Object.values(PLAN_RESOURCES) } };
  }
};

// Obter plano atual do usuário
// Retorna: { plan: { id, name, status, aquisition_date, expiration_date }, features: [...] }
export const getCurrentPlan = async () => {
  try {
    const response = await api.get(ACCOUNT_PLAN_CURRENT_URL);
    return response;
  } catch (error) {
    console.error("Erro ao obter plano atual:", error);
    throw error;
  }
};

// Solicitar upgrade de plano (LEGACY - usar upgradePlan para novo endpoint)
export const requestUpgrade = async (targetPlanId, recurrency = "MONTHLY") => {
  try {
    const response = await api.post(`${PLANS_URL}upgrade/`, {
      target_plan_id: targetPlanId,
      recurrency: recurrency
    });
    return response;
  } catch (error) {
    console.error("Erro ao solicitar upgrade:", error);
    throw error;
  }
};

// Upgrade de plano (novo endpoint)
// POST /account/plan/upgrade/ - { new_plan_id: integer }
export const upgradePlan = async (newPlanId) => {
  try {
    const response = await api.post(ACCOUNT_PLAN_UPGRADE_URL, {
      new_plan_id: parseInt(newPlanId)
    });
    return response;
  } catch (error) {
    console.error("Erro ao fazer upgrade de plano:", error);
    throw error;
  }
};

// Contratar/Reativar plano (para usuários sem plano ativo ou com plano expirado/cancelado)
// POST /account/plan/subscribe/ - { plan_id: integer }
export const subscribePlan = async (planId) => {
  try {
    const response = await api.post(ACCOUNT_PLAN_SUBSCRIBE_URL, {
      plan_id: parseInt(planId)
    });
    return response;
  } catch (error) {
    console.error("Erro ao contratar plano:", error);
    throw error;
  }
};

// Preview do upgrade de plano
// POST /account/plan/upgrade/preview/ - { new_plan_id: integer }
export const previewUpgrade = async (newPlanId) => {
  try {
    const response = await api.post(ACCOUNT_PLAN_UPGRADE_PREVIEW_URL, {
      new_plan_id: parseInt(newPlanId)
    });
    return response;
  } catch (error) {
    console.error("Erro ao obter preview do upgrade:", error);
    throw error;
  }
};

// Preview do cancelamento de plano
// GET /account/plan/cancel/preview/
export const previewCancelPlan = async () => {
  try {
    const response = await api.get(ACCOUNT_PLAN_CANCEL_PREVIEW_URL);
    return response;
  } catch (error) {
    console.error("Erro ao obter preview do cancelamento:", error);
    throw error;
  }
};

// Cancelar plano
// POST /account/plan/cancel/ - { confirm: true, reason: string, feedback?: string }
export const cancelPlan = async (reason, feedback = null) => {
  try {
    const payload = {
      confirm: true,
      reason: reason
    };

    if (feedback) {
      payload.feedback = feedback;
    }

    const response = await api.post(ACCOUNT_PLAN_CANCEL_URL, payload);
    return response;
  } catch (error) {
    console.error("Erro ao cancelar plano:", error);
    throw error;
  }
};

// Contratar addon
export const contractAddon = async (addonId, quantity = 1) => {
  try {
    const response = await api.post(`${PLANS_URL}addons/contract/`, {
      addon_id: addonId,
      quantity: quantity
    });
    return response;
  } catch (error) {
    console.error("Erro ao contratar addon:", error);
    throw error;
  }
};

// =============================
// HELPER FUNCTIONS
// =============================

// Formatar valor para exibição em BRL
export const formatCurrency = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(parseFloat(value));
};

// Formatar data para exibição
export const formatDate = (dateString) => {
  if (!dateString) return "—";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  } catch (error) {
    return "Data inválida";
  }
};

// Obter variante do badge para status do plano
export const getPlanStatusVariant = (status) => {
  const variants = {
    ACTIVE: "success",
    SUSPENDED: "warning",
    CANCELED: "danger",
    EXPIRED: "secondary",
    PENDING: "info"
  };
  return variants[status] || "secondary";
};

// Obter texto do status do plano
export const getPlanStatusText = (status) => {
  const texts = {
    ACTIVE: "Ativo",
    SUSPENDED: "Suspenso",
    CANCELED: "Cancelado",
    EXPIRED: "Expirado",
    PENDING: "Pendente"
  };
  return texts[status] || status;
};

// Mapear status numérico do backend para string
export const mapPlanStatus = (numericStatus) => {
  const statusMap = {
    1: "ACTIVE",
    2: "SUSPENDED",
    3: "CANCELED",
    4: "EXPIRED",
    5: "PENDING"
  };
  return statusMap[numericStatus] || "UNKNOWN";
};

// Obter texto da recorrência
export const getRecurrencyText = (recurrency) => {
  const texts = {
    MONTHLY: "Mensal",
    QUARTERLY: "Trimestral",
    SEMIANNUALLY: "Semestral",
    YEARLY: "Anual"
  };
  return texts[recurrency] || recurrency;
};

// Obter dados do plano por ID (suporta ID numérico ou nome)
export const getPlanById = (planId) => {
  const idToKey = {
    "6": "gratuito",
    "7": "starter",
    "3": "ondemand",
    "5": "business",
    "8": "personal_business",
    "9": "white_label",
    "10": "wl_plus",
    "11": "wl_pro",
  };
  const key = idToKey[String(planId)] || planId;
  return PLAN_RESOURCES[key] || null;
};

// Verificar se um plano é superior a outro (para upgrade)
// Pessoais e comerciais usam escalas isoladas — não há upgrade cross-categoria
export const isPlanUpgrade = (currentPlanId, targetPlanId) => {
  // Planos pessoais (usage_type=1)
  const personalTier = {
    "6": 0,   // Gratuito legado
    "7": 1,   // Starter Pessoal
    "8": 2,   // Business Pessoal
  };

  // Planos comerciais (usage_type=2)
  const commercialTier = {
    "3": 0,   // OnDemand legado
    "4": 1,   // PRO legado
    "9": 2,   // White Label
    "5": 3,   // Business legado
    "10": 4,  // WL Plus
    "2": 5,   // Founder legado
    "11": 6,  // WL Pro
  };

  const currentStr = String(currentPlanId);
  const targetStr = String(targetPlanId);

  // Upgrade dentro de planos pessoais
  if (currentStr in personalTier && targetStr in personalTier) {
    return personalTier[targetStr] > personalTier[currentStr];
  }

  // Upgrade dentro de planos comerciais
  if (currentStr in commercialTier && targetStr in commercialTier) {
    return commercialTier[targetStr] > commercialTier[currentStr];
  }

  // Cross-categoria (pessoal ↔ comercial) não é considerado upgrade
  return false;
};

// Obter recursos de um plano organizados por categoria
export const getPlanResourcesByCategory = (planId) => {
  const plan = PLAN_RESOURCES[planId];
  if (!plan) return {};

  const categorized = {};

  Object.entries(RESOURCE_CATEGORIES).forEach(([key, category]) => {
    categorized[key] = {
      ...category,
      items: category.resources
        .map(resourceKey => ({
          key: resourceKey,
          ...plan.resources[resourceKey]
        }))
        .filter(item => item.label)
    };
  });

  return categorized;
};

// Comparar recursos entre dois planos
export const comparePlans = (planId1, planId2) => {
  const plan1 = PLAN_RESOURCES[planId1];
  const plan2 = PLAN_RESOURCES[planId2];

  if (!plan1 || !plan2) return null;

  const comparison = {};
  const allResourceKeys = new Set([
    ...Object.keys(plan1.resources),
    ...Object.keys(plan2.resources)
  ]);

  allResourceKeys.forEach(key => {
    comparison[key] = {
      label: plan1.resources[key]?.label || plan2.resources[key]?.label,
      plan1: plan1.resources[key],
      plan2: plan2.resources[key]
    };
  });

  return comparison;
};

// Processar resposta de erro da API
export const processPlanError = (error) => {
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data;

    if (status === 400 && data) {
      if (data.error) {
        return { message: data.error, status };
      }
      const messages = Object.values(data).flat();
      return { message: messages.join(', '), status };
    }

    if (status === 404) {
      return { message: "Plano não encontrado", status };
    }

    if (status === 403) {
      return { message: "Sem permissão para esta operação", status };
    }

    return { message: data?.message || data?.error || "Erro no servidor", status };
  }

  return { message: "Erro de conexão. Verifique sua internet.", status: null };
};

export default {
  getAvailablePlans,
  getCurrentPlan,
  requestUpgrade,
  upgradePlan,
  subscribePlan,
  previewUpgrade,
  previewCancelPlan,
  cancelPlan,
  contractAddon,
  formatCurrency,
  formatDate,
  getPlanStatusVariant,
  getPlanStatusText,
  mapPlanStatus,
  getRecurrencyText,
  getPlanById,
  isPlanUpgrade,
  getPlanResourcesByCategory,
  comparePlans,
  processPlanError,
  PLAN_RESOURCES,
  RESOURCE_CATEGORIES
};
